"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestmentBanks = void 0;
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var Resources_1 = require("../../../Resources");
var Card_1 = require("../../Card");
var CardRenderer_1 = require("../../render/CardRenderer");
var InvestmentBanks = (function (_super) {
    __extends(InvestmentBanks, _super);
    function InvestmentBanks() {
        return _super.call(this, {
            cost: 12,
            name: CardName_1.CardName.INVESTMENT_BANKS,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'L409',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(4); });
                }),
                description: 'Increase your M€ production 4 steps.',
            },
        }) || this;
    }
    InvestmentBanks.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 4);
        return undefined;
    };
    return InvestmentBanks;
}(Card_1.Card));
exports.InvestmentBanks = InvestmentBanks;
//# sourceMappingURL=InvestmentBanks.js.map